import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useMemo,
  useState,
} from "react";
import style from "css/hotdesking.module.css";
import Menu from "./Menu";
import PlanCanvas from "./PlanCanvas";
import Search from "./Search";
import {
  Alert,
  Avatar,
  Button,
  Checkbox,
  ConfigProvider,
  Input,
  Modal,
  Radio,
  Tag,
  TimePicker,
} from "antd";
import { ReactComponent as AlretIcon } from "asset/hotdesking/alret.svg";
import { ReactComponent as SendIcon } from "asset/hotdesking/send.svg";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import HotdeskingConfig from "../Config";
import axios from "axios";
import {
  ClockCircleOutlined,
  CloseOutlined,
  DownCircleOutlined,
  PlusOutlined,
  QuestionCircleOutlined,
  RightOutlined,
  UnorderedListOutlined,
  UserOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import Loading from "components/common/Loading";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
dayjs.extend(duration);

function Page() {
  const { t } = useTranslation();
  //system redux
  const systemPayload = useSelector((state) => state.system);

  const navigate = useNavigate();
  const navData = useLocation();

  //Modal State
  const [init, setInit] = useState(true);
  const [isBook, setIsBook] = useState(false);
  const [isBookEndpoint, setIsBookEndpoint] = useState(false);
  const [isCancel, setIsCancel] = useState(false);
  const [isCheckIn, setIsCheckIn] = useState(false);
  const [isCheckOut, setIsCheckOut] = useState(false);
  const [isExtend, setIsExtend] = useState(false);
  const [isShare, setIsShare] = useState(false);
  const [isError, setIsError] = useState(false);
  //Error State
  const [errorMessage, setErrorMessage] = useState(null);
  //Book State
  const [book, setBook] = useState(null);
  const [resource, setResource] = useState(null);
  const [findInfo, setFindInfo] = useState(null);
  //Refresh State
  const [initCanvas, setInitCanvas] = useState(false);
  const [isDepartmentFind, setIsDepartmentFind] = useState(false);
  const [isCanvasFind, setIsCanvasFind] = useState(false);
  const [isResourceFind, setIsResourceFind] = useState(false);
  const [isRefresh, setIsRefresh] = useState(false);
  //Loading State
  const [isMenuLoading, setMenuLoading] = useState(true);
  //Date & Time State
  const [serverDate, setServerDate] = useState("");
  const [date, setDate] = useState(dayjs(new Date()).format("YYYY-MM-DD"));
  const [time, setTime] = useState({
    start: "00:00",
    end: "00:00",
  });
  const [workTime, setWorkTime] = useState({
    start: "",
    end: "",
  });
  //Department State
  const [departmentId, setDepartmentId] = useState(null);
  //Location State
  const [locationDepartmentList, setLocationDepartmentList] = useState([]);
  const [locationList, setLocationList] = useState([]);
  const [location, setLocation] = useState(null);
  //Canvas State
  const [bookList, setBookList] = useState([]);
  const [resourceList, setResourceList] = useState([]);

  const getWorkTime = useCallback(() => {
    axios
      .get(`${HotdeskingConfig.baseURI}/worktime`)
      .then((res) => {
        setTime({
          start: res.data.startTime,
          end: res.data.endTime,
        });
        setWorkTime({
          start: res.data.workStartTime,
          end: res.data.workEndTime,
        });
        setServerDate(res.data.currentDate);
        setInitCanvas(true);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const getLocationDepartmentList = useCallback(() => {
    axios.get(`${HotdeskingConfig.baseURI}/location/department`).then((res) => {
      if (res.data !== "") {
        const list = [];
        res.data.forEach((item) => {
          list.push({
            value: item.id,
            label: item.name,
            parentId: item.parentId !== undefined ? item.parentId : "",
          });
        });
        setLocationDepartmentList(list);
      }
    });
  }, []);

  //Change Location Event
  const onSelectLocation = useCallback((location) => {
    if (!location) {
      setLocation(null);
      setIsRefresh(true);
    } else {
      setLocation(location);
      setInitCanvas(true);
    }
  }, []);

  const getLocationList = useCallback(() => {
    axios
      .get(`${HotdeskingConfig.baseURI}/location/list`)
      .then((res) => {
        setLocationList(res.data);
        res.data.forEach((item) => {
          if (item.defaultYn === "Y") {
            setDepartmentId(item.departmentId);
            setLocation(item);
            setIsDepartmentFind(true);
          }
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  //Menu Func
  const getBook = useCallback(() => {
    setMenuLoading(true);
    axios
      .get(`${HotdeskingConfig.baseURI}/book`)
      .then((res) => {
        if (res.data === "") {
          setBook(null);
        } else {
          setBook(res.data);
        }
      })
      .catch(() => {})
      .finally(() => {
        setMenuLoading(false);
      });
  }, []);

  //Canvas Func
  const getBookList = useCallback(() => {
    const config = {
      params: {
        location_id: location.id,
        start_dttm: date + " " + time.start,
        end_dttm: date + " " + time.end,
      },
    };
    axios.get(`${HotdeskingConfig.baseURI}/book/list`, config).then((res) => {
      setBookList(res.data);
    });
  }, [date, location, time.end, time.start]);

  const getResourseList = useCallback(() => {
    const config = {
      params: {
        location_id: location.id,
      },
    };
    axios
      .get(`${HotdeskingConfig.baseURI}/resource/list`, config)
      .then((res) => {
        setResourceList(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [location]);

  //자리 확인
  const onShowBook = useCallback(
    (book) => {
      if (book && book !== null) {
        setFindInfo(book);
        setDate(dayjs(new Date(book.startDttm)).format("YYYY-MM-DD"));
        setTime({
          // start: dayjs(new Date(book.startDttm)).format("HH:mm"),
          start: dayjs(new Date()).format("HH:mm"),
          end: dayjs(new Date(book.endDttm)).format("HH:mm"),
        });
        //search
        setDepartmentId(book.resource.location.departmentId);
        setIsDepartmentFind(true);
        //canvas
        onSelectLocation(book.resource.location);
        setIsCanvasFind(true);
      }
    },
    [onSelectLocation]
  );

  useMemo(() => {
    getWorkTime();
  }, [getWorkTime]);

  useMemo(() => {
    getLocationDepartmentList();
  }, [getLocationDepartmentList]);

  useMemo(() => {
    getLocationList();
  }, [getLocationList]);

  useMemo(() => {
    getBook();
  }, [getBook]);

  useEffect(() => {
    if (
      init &&
      navData !== null &&
      navData?.state !== null &&
      navData?.state?.id !== null &&
      navData?.state?.id !== undefined &&
      locationDepartmentList.length > 0 &&
      locationList.length > 0
    ) {
      onShowBook(navData?.state);
      navigate(navData.pathname, { replace: true, state: null });
      setInit(false);
    }
  }, [
    init,
    locationDepartmentList.length,
    locationList.length,
    navData,
    navigate,
    onShowBook,
  ]);

  //Canvas Initial Event
  useLayoutEffect(() => {
    if (initCanvas && location != null) {
      getBookList();
      getResourseList();
      setIsRefresh(true);
      setInitCanvas(false);
    }
  }, [getBookList, getResourseList, initCanvas, location]);

  const onRefresh = () => {
    getBook();
    setInitCanvas(true);
  };

  //Change Date Event
  const onSelectDate = (date) => {
    setDate(date);
    if (date !== serverDate) {
      setTime({
        start: workTime.start,
        end: workTime.end,
      });
      setInitCanvas(true);
    } else {
      getWorkTime();
    }
  };

  //Change Time Event
  const onSelectTime = (time) => {
    if (date !== serverDate) {
      setTime(time);
    } else {
      const currentTime = dayjs(new Date()).format("HH:mm");

      if (time.end < currentTime) {
        return;
      }

      if (time.start < currentTime) {
        setTime({
          start: currentTime,
          end: time.end,
        });
        return;
      }
      setTime(time);
    }
    setInitCanvas(true);
  };

  //에러 팝업
  const onOpenErrorModal = (message) => {
    setErrorMessage(message);
    setIsError(true);
  };
  const onCloseErrorModal = () => {
    setErrorMessage(null);
    setIsError(false);
  };

  //예약 팝업
  const onOpenBookModal = (resource) => {
    setResource(resource);

    if (!systemPayload.isOnline) {
      setIsBook(true);
      return;
    }

    if (resource.type === "CD1401" && resource.endpoint !== undefined) {
      //화상회의 장비가 있는 회의실
      setIsBookEndpoint(true);
    } else {
      setIsBook(true);
    }
  };
  const onCloseBookEndpointModal = () => {
    setResource(null);
    setIsBookEndpoint(false);
  };
  const onCloseBookModal = () => {
    setResource(null);
    setIsBook(false);
  };
  //취소 팝업
  const onOpenCancelModal = () => {
    setIsCancel(true);
  };
  const onCloseCancelModal = () => {
    setIsCancel(false);
  };
  //체크인인 팝업
  const onOpenCheckInModal = () => {
    setIsCheckIn(true);
  };
  const onCloseCheckInModal = () => {
    setIsCheckIn(false);
  };
  //체크아웃 팝업
  const onOpenCheckOutModal = () => {
    setIsCheckOut(true);
  };
  const onCloseCheckOutModal = () => {
    setIsCheckOut(false);
  };
  //연장 팝업
  const onOpenExtendModal = () => {
    setIsExtend(true);
  };
  const onCloseExtendModal = () => {
    setIsExtend(false);
  };
  //공유 팝업
  const onOpenSahreModal = () => {
    setIsShare(true);
  };
  const onCloseShareModal = () => {
    setIsShare(false);
  };

  //Banner
  const onCloseBanner = () => {
    setIsRefresh(true);
  };

  const onShowResource = (resource) => {
    if (resource && resource !== null) {
      setFindInfo({
        date: date,
        time: {
          start: time.start,
          end: time.end,
        },
        resource: {
          title: resource.title,
          coordinateX: resource.coordinateX,
          coordinateY: resource.coordinateY,
        },
      });
      // //search
      setDepartmentId(resource.department.id);
      setIsDepartmentFind(true);
      // //canvas
      onSelectLocation(resource.location);
      setIsResourceFind(true);
    }
  };

  return (
    <>
      <ErrorModal
        open={isError}
        message={errorMessage}
        onClose={onCloseErrorModal}
      />
      <BookEndpointModal
        open={isBookEndpoint}
        date={date}
        time={time}
        resource={resource}
        onClose={onCloseBookEndpointModal}
        onRefresh={onRefresh}
        onError={onOpenErrorModal}
      />
      <BookModal
        open={isBook}
        date={date}
        time={time}
        serverDate={serverDate}
        resource={resource}
        setTime={setTime}
        onClose={onCloseBookModal}
        onRefresh={onRefresh}
        onError={onOpenErrorModal}
      />
      <CancelModal
        open={isCancel}
        book={book}
        onClose={onCloseCancelModal}
        onRefresh={onRefresh}
        onError={onOpenErrorModal}
      />
      <CheckInModal
        open={isCheckIn}
        book={book}
        onClose={onCloseCheckInModal}
        onRefresh={onRefresh}
        onError={onOpenErrorModal}
      />
      <CheckOutModal
        open={isCheckOut}
        book={book}
        onClose={onCloseCheckOutModal}
        onRefresh={onRefresh}
        onError={onOpenErrorModal}
      />
      <ExtendModal
        open={isExtend}
        book={book}
        onClose={onCloseExtendModal}
        onRefresh={onRefresh}
        onError={onOpenErrorModal}
      />
      <ShareModal
        open={isShare}
        book={book}
        onClose={onCloseShareModal}
        onError={onOpenErrorModal}
      />

      <section className={style.wrapper}>
        <section className={style.container}>
          <Menu
            data={book}
            onCancel={onOpenCancelModal}
            onCheckIn={onOpenCheckInModal}
            onCheckOut={onOpenCheckOutModal}
            onExtend={onOpenExtendModal}
            onShare={onOpenSahreModal}
            onShowBook={onShowBook}
            onShowResource={onShowResource}
            onBook={onOpenBookModal}
            onError={onOpenErrorModal}
            date={date}
            time={time}
            isLoading={isMenuLoading}
          />
          <section className={style.content}>
            <Alert
              className={style.header}
              message={
                <article className={style.comment}>
                  <p>{t("HOTDESKING.HEADLINE.TITLE")}</p>
                  <span className={style.driver} />
                  <p>{t("HOTDESKING.HEADLINE.DESC")}</p>
                </article>
              }
              type="success"
              afterClose={onCloseBanner}
              icon={<AlretIcon />}
              showIcon
              closable
            />
            <Search
              date={date}
              setDate={onSelectDate}
              time={time}
              setTime={onSelectTime}
              location={location}
              setLocation={onSelectLocation}
              bookCnt={bookList.length}
              resourceCnt={resourceList.length}
              locationList={locationList}
              departmentList={locationDepartmentList}
              departmentId={departmentId}
              isFind={isDepartmentFind}
              setIsFind={setIsDepartmentFind}
            />
            <PlanCanvas
              bookList={bookList}
              resourceList={resourceList}
              bookInfo={findInfo}
              isFind={isCanvasFind}
              setIsFind={setIsCanvasFind}
              isResourceFind={isResourceFind}
              setIsResourceFind={setIsResourceFind}
              location={location}
              refresh={isRefresh}
              setRefresh={setIsRefresh}
              onBook={onOpenBookModal}
            />
            <SeatGuide />
          </section>
        </section>
      </section>
    </>
  );
}

export default Page;

function ErrorModal({ open, message, onClose }) {
  const { t } = useTranslation();
  return (
    <Modal
      className={style.modal}
      open={open}
      closable={false}
      mask={false}
      footer={<></>}
      centered
    >
      <section className={`${style.modal_content} ${style.error}`}>
        <WarningOutlined className={style.icon} />
        <section className={style.comment_section}>
          {message !== null &&
            message.split(".").map((item, idx) => <p key={idx}>{item}</p>)}
        </section>
        <section className={style.button_section}>
          <ConfigProvider
            theme={{
              components: {
                Button: {
                  defaultColor: "#fff",
                  defaultBorderColor: "#1cb691",
                  defaultBg: "#1cb691",
                  defaultHoverColor: "#fff",
                  defaultHoverBorderColor: "#1cb591cc",
                  defaultHoverBg: "#1cb591cc",
                  defaultActiveColor: "#fff",
                  defaultActiveBorderColor: "#1cb691",
                  defaultActiveBg: "#1cb691",
                },
              },
            }}
          >
            <Button className={style.button} onClick={onClose}>
              {t("HOTDESKING.BUTTON.CONFIRM")}
            </Button>
          </ConfigProvider>
        </section>
      </section>
    </Modal>
  );
}
function BookModal({
  open,
  date,
  time,
  serverDate,
  resource,
  setTime,
  onClose,
  onRefresh,
  onError,
}) {
  const { t } = useTranslation();
  const [isConfirm, setIsConfirm] = useState(true);
  const [loading, setLoading] = useState(false);

  const formatStartTime = () => {
    if (date === serverDate) {
      const nowTime = dayjs(new Date()).format("HH:mm:ss");

      if (time.start > nowTime) {
        return dayjs(new Date(date + " " + time.start)).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }

      setTime({
        ...time,
        start: nowTime,
      });
      return dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss");
    }
    return dayjs(new Date(date + " " + time.start)).format(
      "YYYY-MM-DD HH:mm:ss"
    );
  };

  const onBook = () => {
    setLoading(true);
    const data = {
      resource_type: resource.type,
      resource_id: resource.id,
      start_dttm: formatStartTime(),
      end_dttm: dayjs(new Date(date + " " + time.end)).format(
        "YYYY-MM-DD HH:mm:ss"
      ),
    };

    if (resource.endpoint !== undefined) {
      const endpoint = {
        endpoint_id: resource.endpoint.id,
        endpoint_name: resource.endpoint.name,
        endpoint_type: resource.endpoint.type,
      };
      data.endpoint = endpoint;
    }

    axios
      .post(`${HotdeskingConfig.baseURI}/book`, data)
      .then(() => {
        setLoading(false);
        setIsConfirm(false);
      })
      .catch((err) => {
        closeModal();
        if (err === undefined || err.response === undefined) {
          onError(t("HOTDESKING.MODAL.BOOKING.MESSAGE.ERROR"));
        } else {
          onError(err.response.data);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const closeModal = () => {
    onClose();
    const timeout = setTimeout(() => {
      setIsConfirm(true);
    }, 500);
    return () => clearTimeout(timeout);
  };
  const onSuccess = () => {
    onRefresh();
    closeModal();
  };

  return (
    <Modal
      className={style.modal}
      open={open}
      closable={false}
      mask={false}
      footer={<></>}
      centered
    >
      <section className={`${style.modal_content} ${style.confrim}`}>
        {isConfirm ? (
          <>
            <QuestionCircleOutlined className={style.icon} />
            <article className={style.comment}>
              <p>{resource?.title}</p>
              <p>{t("HOTDESKING.MODAL.BOOKING.MESSAGE.RESERVE")}</p>
            </article>
            <section className={`${style.button_section} ${style.confirm}`}>
              <ConfigProvider
                theme={{
                  components: {
                    Button: {
                      defaultColor: "#707070",
                      defaultBorderColor: "#707070",
                      defaultBg: "#fff",
                      defaultHoverColor: "#fff",
                      defaultHoverBorderColor: "#707070",
                      defaultHoverBg: "#707070cc",
                      defaultActiveColor: "#707070",
                      defaultActiveBorderColor: "#707070",
                      defaultActiveBg: "#fff",
                    },
                  },
                }}
              >
                <Button
                  className={style.button}
                  onClick={closeModal}
                  disabled={loading}
                >
                  {t("HOTDESKING.BUTTON.CANCEL")}
                </Button>
              </ConfigProvider>
              <ConfigProvider
                theme={{
                  components: {
                    Button: {
                      defaultColor: "#fff",
                      defaultBorderColor: "#1cb691",
                      defaultBg: "#1cb691",
                      defaultHoverColor: "#fff",
                      defaultHoverBorderColor: "#1cb591cc",
                      defaultHoverBg: "#1cb591cc",
                      defaultActiveColor: "#fff",
                      defaultActiveBorderColor: "#1cb691",
                      defaultActiveBg: "#1cb691",
                    },
                  },
                }}
              >
                <Button
                  className={style.button}
                  onClick={() => onBook()}
                  loading={loading}
                >
                  {t("HOTDESKING.BUTTON.CONFIRM")}
                </Button>
              </ConfigProvider>
            </section>
          </>
        ) : (
          <>
            <DownCircleOutlined className={style.icon} />
            <p className={style.comment}>
              {t("HOTDESKING.MODAL.BOOKING.MESSAGE.SUCCESS")}
            </p>
            <section className={style.button_section}>
              <ConfigProvider
                theme={{
                  components: {
                    Button: {
                      defaultColor: "#fff",
                      defaultBorderColor: "#1cb691",
                      defaultBg: "#1cb691",
                      defaultHoverColor: "#fff",
                      defaultHoverBorderColor: "#1cb591cc",
                      defaultHoverBg: "#1cb591cc",
                      defaultActiveColor: "#fff",
                      defaultActiveBorderColor: "#1cb691",
                      defaultActiveBg: "#1cb691",
                    },
                  },
                }}
              >
                <Button className={style.button} onClick={onSuccess}>
                  {t("HOTDESKING.BUTTON.CONFIRM")}
                </Button>
              </ConfigProvider>
            </section>
          </>
        )}
      </section>
    </Modal>
  );
}
function CancelModal({ open, book, onClose, onRefresh, onError }) {
  const { t } = useTranslation();
  const [isConfirm, setIsConfirm] = useState(true);
  const [loading, setLoading] = useState(false);
  const onCancel = () => {
    setLoading(true);
    const config = {
      params: {
        book_id: book.id,
      },
    };
    axios
      .delete(`${HotdeskingConfig.baseURI}/book/cancel`, config)
      .then(() => {
        setLoading(false);
        setIsConfirm(false);
      })
      .catch((err) => {
        closeModal();
        if (err === undefined || err.response === undefined) {
          onError(t("HOTDESKING.MODAL.CANCEL.MESSAGE.ERROR"));
        } else {
          // onError(err.response.data);
          onError(t("HOTDESKING.MODAL.CANCEL.MESSAGE.CANNOT"));
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const closeModal = () => {
    onClose();
    const timeout = setTimeout(() => {
      setIsConfirm(true);
    }, 500);
    return () => clearTimeout(timeout);
  };
  const onSuccess = () => {
    onRefresh();
    closeModal();
  };

  return (
    <Modal
      className={style.modal}
      open={open}
      closable={false}
      mask={false}
      footer={<></>}
      centered
    >
      <section className={`${style.modal_content} ${style.confrim}`}>
        {isConfirm ? (
          <>
            <QuestionCircleOutlined className={style.icon} />
            <p className={style.comment}>
              {t("HOTDESKING.MODAL.CANCEL.MESSAGE.CANCEL")}
            </p>
            <section className={`${style.button_section} ${style.confirm}`}>
              <ConfigProvider
                theme={{
                  components: {
                    Button: {
                      defaultColor: "#707070",
                      defaultBorderColor: "#707070",
                      defaultBg: "#fff",
                      defaultHoverColor: "#fff",
                      defaultHoverBorderColor: "#707070",
                      defaultHoverBg: "#707070cc",
                      defaultActiveColor: "#707070",
                      defaultActiveBorderColor: "#707070",
                      defaultActiveBg: "#fff",
                    },
                  },
                }}
              >
                <Button
                  className={style.button}
                  onClick={closeModal}
                  disabled={loading}
                >
                  {t("HOTDESKING.BUTTON.CANCEL")}
                </Button>
              </ConfigProvider>
              <ConfigProvider
                theme={{
                  components: {
                    Button: {
                      defaultColor: "#fff",
                      defaultBorderColor: "#1cb691",
                      defaultBg: "#1cb691",
                      defaultHoverColor: "#fff",
                      defaultHoverBorderColor: "#1cb591cc",
                      defaultHoverBg: "#1cb591cc",
                      defaultActiveColor: "#fff",
                      defaultActiveBorderColor: "#1cb691",
                      defaultActiveBg: "#1cb691",
                    },
                  },
                }}
              >
                <Button
                  className={style.button}
                  onClick={onCancel}
                  loading={loading}
                >
                  {t("HOTDESKING.BUTTON.CONFIRM")}
                </Button>
              </ConfigProvider>
            </section>
          </>
        ) : (
          <>
            <DownCircleOutlined className={style.icon} />
            <p className={style.comment}>
              {t("HOTDESKING.MODAL.CANCEL.MESSAGE.SUCCESS")}
            </p>
            <section className={style.button_section}>
              <ConfigProvider
                theme={{
                  components: {
                    Button: {
                      defaultColor: "#fff",
                      defaultBorderColor: "#1cb691",
                      defaultBg: "#1cb691",
                      defaultHoverColor: "#fff",
                      defaultHoverBorderColor: "#1cb591cc",
                      defaultHoverBg: "#1cb591cc",
                      defaultActiveColor: "#fff",
                      defaultActiveBorderColor: "#1cb691",
                      defaultActiveBg: "#1cb691",
                    },
                  },
                }}
              >
                <Button className={style.button} onClick={onSuccess}>
                  {t("HOTDESKING.BUTTON.CONFIRM")}
                </Button>
              </ConfigProvider>
            </section>
          </>
        )}
      </section>
    </Modal>
  );
}
function CheckInModal({ open, book, onClose, onRefresh, onError }) {
  const { t } = useTranslation();
  const [isConfirm, setIsConfirm] = useState(true);
  const [loading, setLoading] = useState(false);
  const onCheckIn = () => {
    setLoading(true);
    const data = {
      book_id: book.id,
      start_dttm: book.startDttm,
      status: "IN_USE",
    };
    axios
      .put(`${HotdeskingConfig.baseURI}/book/status`, data)
      .then(() => {
        setLoading(false);
        setIsConfirm(false);
      })
      .catch((err) => {
        closeModal();
        if (err === undefined || err.response === undefined) {
          onError(t("HOTDESKING.MODAL.CHECK_IN.MESSAGE.ERROR"));
        } else {
          onError(err.response.data);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const closeModal = () => {
    onClose();
    const timeout = setTimeout(() => {
      setIsConfirm(true);
    }, 500);
    return () => clearTimeout(timeout);
  };
  const onSuccess = () => {
    onRefresh();
    closeModal();
  };

  return (
    <Modal
      className={style.modal}
      open={open}
      closable={false}
      mask={false}
      footer={<></>}
      centered
    >
      <section className={`${style.modal_content} ${style.confrim}`}>
        {isConfirm ? (
          <>
            <QuestionCircleOutlined className={style.icon} />
            <p className={style.comment}>
              {t("HOTDESKING.MODAL.CHECK_IN.MESSAGE.CHECK_IN")}
            </p>
            <section className={`${style.button_section} ${style.confirm}`}>
              <ConfigProvider
                theme={{
                  components: {
                    Button: {
                      defaultColor: "#707070",
                      defaultBorderColor: "#707070",
                      defaultBg: "#fff",
                      defaultHoverColor: "#fff",
                      defaultHoverBorderColor: "#707070",
                      defaultHoverBg: "#707070cc",
                      defaultActiveColor: "#707070",
                      defaultActiveBorderColor: "#707070",
                      defaultActiveBg: "#fff",
                    },
                  },
                }}
              >
                <Button
                  className={style.button}
                  onClick={closeModal}
                  disabled={loading}
                >
                  {t("HOTDESKING.BUTTON.CANCEL")}
                </Button>
              </ConfigProvider>
              <ConfigProvider
                theme={{
                  components: {
                    Button: {
                      defaultColor: "#fff",
                      defaultBorderColor: "#1cb691",
                      defaultBg: "#1cb691",
                      defaultHoverColor: "#fff",
                      defaultHoverBorderColor: "#1cb591cc",
                      defaultHoverBg: "#1cb591cc",
                      defaultActiveColor: "#fff",
                      defaultActiveBorderColor: "#1cb691",
                      defaultActiveBg: "#1cb691",
                    },
                  },
                }}
              >
                <Button
                  className={style.button}
                  onClick={onCheckIn}
                  loading={loading}
                >
                  {t("HOTDESKING.BUTTON.CONFIRM")}
                </Button>
              </ConfigProvider>
            </section>
          </>
        ) : (
          <>
            <DownCircleOutlined className={style.icon} />
            <p className={style.comment}>
              {t("HOTDESKING.MODAL.CHECK_IN.MESSAGE.SUCCESS")}
            </p>
            <section className={style.button_section}>
              <ConfigProvider
                theme={{
                  components: {
                    Button: {
                      defaultColor: "#fff",
                      defaultBorderColor: "#1cb691",
                      defaultBg: "#1cb691",
                      defaultHoverColor: "#fff",
                      defaultHoverBorderColor: "#1cb591cc",
                      defaultHoverBg: "#1cb591cc",
                      defaultActiveColor: "#fff",
                      defaultActiveBorderColor: "#1cb691",
                      defaultActiveBg: "#1cb691",
                    },
                  },
                }}
              >
                <Button className={style.button} onClick={onSuccess}>
                  {t("HOTDESKING.BUTTON.CONFIRM")}
                </Button>
              </ConfigProvider>
            </section>
          </>
        )}
      </section>
    </Modal>
  );
}
function CheckOutModal({ open, book, onClose, onRefresh, onError }) {
  const { t } = useTranslation();
  const [isConfirm, setIsConfirm] = useState(true);
  const [loading, setLoading] = useState(false);
  const onCheckOut = () => {
    setLoading(true);
    const data = {
      book_id: book.id,
      status: "END_USE",
    };
    axios
      .put(`${HotdeskingConfig.baseURI}/book/status`, data)
      .then(() => {
        setLoading(false);
        setIsConfirm(false);
      })
      .catch((err) => {
        closeModal();
        if (err === undefined || err.response === undefined) {
          onError(t("HOTDESKING.MODAL.CHECK_OUT.MESSAGE.ERROR"));
        } else {
          onError(err.response.data);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const closeModal = () => {
    onClose();
    const timeout = setTimeout(() => {
      setIsConfirm(true);
    }, 500);
    return () => clearTimeout(timeout);
  };
  const onSuccess = () => {
    onRefresh();
    closeModal();
  };

  return (
    <Modal
      className={style.modal}
      open={open}
      closable={false}
      mask={false}
      footer={<></>}
      centered
    >
      <section className={`${style.modal_content} ${style.confrim}`}>
        {isConfirm ? (
          <>
            <QuestionCircleOutlined className={style.icon} />
            <p className={style.comment}>
              {t("HOTDESKING.MODAL.CHECK_OUT.MESSAGE.CHECK_OUT")}
            </p>
            <section className={`${style.button_section} ${style.confirm}`}>
              <ConfigProvider
                theme={{
                  components: {
                    Button: {
                      defaultColor: "#707070",
                      defaultBorderColor: "#707070",
                      defaultBg: "#fff",
                      defaultHoverColor: "#fff",
                      defaultHoverBorderColor: "#707070",
                      defaultHoverBg: "#707070cc",
                      defaultActiveColor: "#707070",
                      defaultActiveBorderColor: "#707070",
                      defaultActiveBg: "#fff",
                    },
                  },
                }}
              >
                <Button
                  className={style.button}
                  onClick={closeModal}
                  disabled={loading}
                >
                  {t("HOTDESKING.BUTTON.CANCEL")}
                </Button>
              </ConfigProvider>
              <ConfigProvider
                theme={{
                  components: {
                    Button: {
                      defaultColor: "#fff",
                      defaultBorderColor: "#1cb691",
                      defaultBg: "#1cb691",
                      defaultHoverColor: "#fff",
                      defaultHoverBorderColor: "#1cb591cc",
                      defaultHoverBg: "#1cb591cc",
                      defaultActiveColor: "#fff",
                      defaultActiveBorderColor: "#1cb691",
                      defaultActiveBg: "#1cb691",
                    },
                  },
                }}
              >
                <Button
                  className={style.button}
                  onClick={onCheckOut}
                  loading={loading}
                >
                  {t("HOTDESKING.BUTTON.CONFIRM")}
                </Button>
              </ConfigProvider>
            </section>
          </>
        ) : (
          <>
            <DownCircleOutlined className={style.icon} />
            <p className={style.comment}>
              {t("HOTDESKING.MODAL.CHECK_OUT.MESSAGE.SUCCESS")}
            </p>
            <section className={style.button_section}>
              <ConfigProvider
                theme={{
                  components: {
                    Button: {
                      defaultColor: "#fff",
                      defaultBorderColor: "#1cb691",
                      defaultBg: "#1cb691",
                      defaultHoverColor: "#fff",
                      defaultHoverBorderColor: "#1cb591cc",
                      defaultHoverBg: "#1cb591cc",
                      defaultActiveColor: "#fff",
                      defaultActiveBorderColor: "#1cb691",
                      defaultActiveBg: "#1cb691",
                    },
                  },
                }}
              >
                <Button className={style.button} onClick={onSuccess}>
                  {t("HOTDESKING.BUTTON.CONFIRM")}
                </Button>
              </ConfigProvider>
            </section>
          </>
        )}
      </section>
    </Modal>
  );
}
function ExtendModal({ open, book, onClose, onRefresh, onError }) {
  const { t, i18n } = useTranslation();
  const [init, setInit] = useState(true);
  const [isActive, setIsActive] = useState(false);
  const [loading, setLoading] = useState(false);
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [duration, setDuration] = useState(0);
  const [availableExtendTime, setAvailableExtendTime] = useState(0);

  const getDefaultTime = useCallback(() => {
    setDate(dayjs(new Date(book.endDttm)).format("YYYY-MM-DD"));
    setTime(dayjs(new Date(book.endDttm)));
  }, [book]);

  const getAvailableExtendTime = useCallback(() => {
    const config = {
      params: {
        resource_id: book.resource.id,
        max_dttm:
          dayjs(new Date(book.endDttm)).format("YYYY-MM-DD") + " 23:59:59",
        end_dttm: dayjs(new Date(book.endDttm)).format("YYYY-MM-DD HH:mm:ss"),
      },
    };
    axios.get(`${HotdeskingConfig.baseURI}/book/extend`, config).then((res) => {
      setAvailableExtendTime(res.data - 1);
    });
  }, [book]);

  useLayoutEffect(() => {
    if (open && init) {
      getDefaultTime();
      getAvailableExtendTime();
      setInit(false);
    }
  }, [getAvailableExtendTime, getDefaultTime, init, open]);

  const getMinutesDiff = (startDttm, endDttm) => {
    const format = "HH:mm";
    const t1 = dayjs(startDttm, format);
    const t2 = dayjs(endDttm, format);
    return t2.diff(t1, "minute");
  };

  const addMinutes = (dateTime, minutes) => {
    const format = "HH:mm";
    return dayjs(dateTime, "YYYY-MM-DD HH:mm")
      .add(minutes, "minute")
      .format(format);
  };

  const onExtend = () => {
    setLoading(true);
    const data = {
      book_id: book.id,
      resource_id: book.resource.id,
      end_dttm: time.format("YYYY-MM-DD HH:mm"),
      reference_dttm: dayjs(new Date(book.endDttm)).format("YYYY-MM-DD HH:mm"),
      duration: duration,
    };
    axios
      .put(`${HotdeskingConfig.baseURI}/book/extend`, data)
      .then(() => {
        onRefresh();
        closeModal();
      })
      .catch((err) => {
        onRefresh();
        closeModal();
        if (err === undefined || err.response === undefined) {
          onError(t("HOTDESKING.MODAL.EXTEND.MESSAGE.ERROR"));
        } else {
          onError(err.response.data);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onChange = (value) => {
    const extendTime = dayjs(value, "HH:mm");
    const endTime = dayjs(new Date(book.endDttm)).format("HH:mm");

    if (extendTime.format("HH:mm") < endTime) {
      setTime(dayjs(new Date(book.endDttm)));
      setIsActive(false);
      return;
    }

    const duration = getMinutesDiff(endTime, extendTime.format("HH:mm"));
    const startTime = dayjs(new Date(book.startDttm)).format("HH:mm");

    if (duration > availableExtendTime) {
      const maxEndTime = addMinutes(book.endDttm, availableExtendTime);
      setDuration(getMinutesDiff(startTime, maxEndTime));
      setTime(dayjs(maxEndTime, "HH:mm"));
    } else {
      setDuration(getMinutesDiff(startTime, extendTime));
      setTime(extendTime);
    }
    setIsActive(true);
  };

  const closeModal = () => {
    onClose();
    setInit(true);
  };

  const formatDuration = () => {
    let hours = Math.floor(availableExtendTime / 60);
    let mins = availableExtendTime % 60;
    if (i18n.language === "ko-KR") {
      return `${String(hours).padStart(2, "0")}시간 ${String(mins).padStart(
        2,
        "0"
      )}분`;
    } else {
      return `${String(hours).padStart(2, "0")}:${String(mins).padStart(
        2,
        "0"
      )}`;
    }
  };

  return (
    <Modal
      className={style.modal}
      open={open}
      closable={false}
      mask={false}
      footer={<></>}
      centered
    >
      <section className={`${style.modal_content} ${style.extend}`}>
        <section className={style.content_header}>
          <p className={style.header_title}>
            {t("HOTDESKING.MODAL.EXTEND.TITLE")}
          </p>
          <CloseOutlined className={style.header_icon} onClick={closeModal} />
        </section>

        <section className={style.content_section}>
          <article className={style.extend_article}>
            <p>{t("HOTDESKING.MODAL.EXTEND.AVAILABLE_EXTEND_TIME")}</p>
            <span className={style.driver} />
            <p>{formatDuration()}</p>
          </article>

          <div className={style.item}>
            <p className={style.title}>
              {t("HOTDESKING.MODAL.EXTEND.EXPIRATION_TIME")}
            </p>
            <section className={style.input_section}>
              <Input value={date} readOnly />
              <TimePicker
                format={"HH:mm"}
                onChange={onChange}
                suffixIcon={<ClockCircleOutlined />}
                value={time}
                allowClear={false}
                showNow={false}
                changeOnScroll
                inputReadOnly
              />
            </section>
          </div>
        </section>

        <section className={style.button_section}>
          <ConfigProvider
            theme={{
              components: {
                Button: {
                  defaultColor: "#707070",
                  defaultBorderColor: "#707070",
                  defaultBg: "#fff",
                  defaultHoverColor: "#fff",
                  defaultHoverBorderColor: "#707070",
                  defaultHoverBg: "#707070cc",
                  defaultActiveColor: "#707070",
                  defaultActiveBorderColor: "#707070",
                  defaultActiveBg: "#fff",
                },
              },
            }}
          >
            <Button
              className={style.button}
              onClick={closeModal}
              disabled={loading}
            >
              {t("HOTDESKING.BUTTON.CANCEL")}
            </Button>
          </ConfigProvider>
          <ConfigProvider
            theme={{
              components: {
                Button: {
                  defaultColor: "#fff",
                  defaultBorderColor: "#1cb691",
                  defaultBg: "#1cb691",
                  defaultHoverColor: "#fff",
                  defaultHoverBorderColor: "#1cb591cc",
                  defaultHoverBg: "#1cb591cc",
                  defaultActiveColor: "#fff",
                  defaultActiveBorderColor: "#1cb691",
                  defaultActiveBg: "#1cb691",
                },
              },
            }}
          >
            <Button
              className={style.button}
              onClick={onExtend}
              loading={loading}
              disabled={!isActive}
            >
              {t("HOTDESKING.BUTTON.CONFIRM")}
            </Button>
          </ConfigProvider>
        </section>
      </section>
    </Modal>
  );
}
function ShareModal({ open, book, onClose, onError }) {
  const { t } = useTranslation();
  const options = [
    {
      label: (
        <Trans
          i18nKey="HOTDESKING.MODAL.SHARE.MY_TEAM.DESC"
          components={{ strong: <strong /> }}
        />
      ),
      title: t("HOTDESKING.MODAL.SHARE.MY_TEAM.TITLE"),
      type: "department",
    },
    {
      label: (
        <Trans
          i18nKey="HOTDESKING.MODAL.SHARE.FAVORITE.DESC"
          components={{ strong: <strong /> }}
        />
      ),
      title: t("HOTDESKING.MODAL.SHARE.FAVORITE.TITLE"),
      type: "favorite",
    },
  ];
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState("");
  const [title, setTitle] = useState("");
  const [search, setSearch] = useState(true);
  const [expand, setExpand] = useState(false);
  const [memberList, setMemberList] = useState([]);
  const [checkList, setCheckList] = useState([]);

  const getMemberList = useCallback(() => {
    setLoading(true);
    const config = {
      params: {
        search_type: type,
      },
    };

    if (type === "share") {
      config.params.book_id = book.id;
    }

    axios
      .get(`${HotdeskingConfig.baseURI}/member`, config)
      .then((res) => {
        setMemberList(res.data);
      })
      .finally(() => {
        setCheckList([]);
        setLoading(false);
      });
  }, [book, type]);

  useEffect(() => {
    if (open && expand && search) {
      getMemberList();
      setSearch(false);
    }
  }, [getMemberList, expand, open, search]);

  const closeModal = () => {
    onClose();
    const timeout = setTimeout(() => {
      setType("");
      setTitle("");
      setMemberList([]);
      setCheckList([]);
      setExpand(false);
    }, 500);
    return () => clearTimeout(timeout);
  };

  const onExpand = (type, title) => {
    setMemberList([]);
    setType(type);
    setTitle(title);
    setSearch(true);
    setExpand(true);
  };

  const onCheck = (list) => {
    setCheckList(list);
  };

  const onShare = () => {
    setLoading(true);
    const data = {
      book_id: book.id,
      member_list: checkList,
    };
    axios
      .post(`${HotdeskingConfig.baseURI}/book/share`, data)
      .then(() => {
        closeModal();
      })
      .catch((err) => {
        closeModal();
        if (err === undefined || err.response === undefined) {
          onError(t("HOTDESKING.MODAL.SHARE.MESSAGE.ERROR"));
        } else {
          onError(err.response.data);
        }
      });
  };

  const onCancel = (member_id) => {
    setLoading(true);
    const config = {
      params: {
        book_id: book.id,
        member_id: member_id,
      },
    };
    axios
      .delete(`${HotdeskingConfig.baseURI}/book/share`, config)
      .then(() => {
        setSearch(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Modal
      className={style.modal}
      open={open}
      closable={false}
      mask={false}
      footer={<></>}
      centered
    >
      <section className={`${style.modal_content} ${style.share}`}>
        <section className={style.content_header}>
          <p className={style.header_title}>
            {t("HOTDESKING.MODAL.SHARE.TITLE")}
          </p>
          <CloseOutlined className={style.header_icon} onClick={closeModal} />
        </section>

        <section
          className={
            expand
              ? `${style.content_section} ${style.expand}`
              : style.content_section
          }
        >
          <section className={style.menu_section}>
            <section className={style.type_section}>
              <ConfigProvider
                theme={{
                  components: {
                    Button: {
                      defaultColor: "#121212",
                      defaultBorderColor: "#b4b4b4",
                      defaultBg: "#fff",
                      defaultHoverColor: "#1cb691",
                      defaultHoverBorderColor: "#1cb691",
                      defaultHoverBg: "#fff",
                      defaultActiveColor: "#fff",
                      defaultActiveBorderColor: "#1cb691",
                      defaultActiveBg: "#1cb691cc",
                    },
                  },
                }}
              >
                {options.map((item, idx) => (
                  <Button
                    key={idx}
                    className={style.item}
                    onClick={() => onExpand(item.type, item.title)}
                  >
                    <div className={style.item_content}>
                      <p className={style.title}>{item.label}</p>
                      <RightOutlined className={style.icon} />
                    </div>
                  </Button>
                ))}
              </ConfigProvider>
            </section>

            <section
              className={style.button_section}
              onClick={() =>
                onExpand("share", t("HOTDESKING.MODAL.SHARE.SHARED.TITLE"))
              }
            >
              <div className={style.button_label}>
                <div className={style.icon}>
                  <UnorderedListOutlined />
                </div>
                <p>{t("HOTDESKING.MODAL.SHARE.SHARED.DESC")}</p>
              </div>
              <RightOutlined className={style.icon} />
            </section>
          </section>

          <section className={style.list_section}>
            <section className={style.list_header}>
              <p>{title}</p>
            </section>
            <section
              className={
                type === "share"
                  ? `${style.list_content} ${style.share}`
                  : style.list_content
              }
            >
              {loading ? (
                <Loading />
              ) : (
                <>
                  <section className={style.list_content_section}>
                    {type === "share" ? (
                      memberList.map((item, idx) => (
                        <div key={idx} className={style.list_share_content}>
                          <div className={style.list_content_item}>
                            <Avatar
                              className={style.user_img}
                              icon={<UserOutlined className={style.icon} />}
                            />
                            <article className={style.user_info}>
                              <p className={style.user_name}>{item.name}</p>
                              <div className={style.user_department}>
                                <p>{item.role}</p>
                                <span className={style.driver} />
                                <p>{item.department.name}</p>
                              </div>
                            </article>
                          </div>

                          <div className={style.cancel_content}>
                            <ConfigProvider
                              theme={{
                                components: {
                                  Button: {
                                    defaultColor: "#121212",
                                    defaultBorderColor: "#121212",
                                    defaultBg: "#fff",
                                    defaultHoverColor: "#f01016",
                                    defaultHoverBorderColor: "#f01016",
                                    defaultHoverBg: "#fff",
                                    defaultActiveColor: "#f01016cc",
                                    defaultActiveBorderColor: "#f01016cc",
                                    defaultActiveBg: "#fff",
                                  },
                                },
                              }}
                            >
                              <Button
                                className={style.button}
                                onClick={() => onCancel(item.id)}
                              >
                                <div className={style.button_content}>
                                  <CloseOutlined />
                                  <p>{t("HOTDESKING.BUTTON.CANCEL")}</p>
                                </div>
                              </Button>
                            </ConfigProvider>
                          </div>
                        </div>
                      ))
                    ) : (
                      <Checkbox.Group
                        options={memberList.map((item, idx) => {
                          return {
                            label: (
                              <div
                                key={idx}
                                className={
                                  checkList.filter((id) => id === item.id)
                                    .length > 0
                                    ? `${style.list_content_item} ${style.checked}`
                                    : style.list_content_item
                                }
                              >
                                <Avatar
                                  className={style.user_img}
                                  icon={<UserOutlined className={style.icon} />}
                                />
                                <article className={style.user_info}>
                                  <p className={style.user_name}>{item.name}</p>
                                  <div className={style.user_department}>
                                    <p>{item.role}</p>
                                    <span className={style.driver} />
                                    <p>{item.department.name}</p>
                                  </div>
                                </article>
                              </div>
                            ),
                            value: item.id,
                          };
                        })}
                        onChange={onCheck}
                      />
                    )}
                  </section>
                  {type !== "share" && (
                    <section className={style.button_section}>
                      <ConfigProvider
                        theme={{
                          components: {
                            Button: {
                              defaultColor: "#fff",
                              defaultBorderColor: "#1cb691",
                              defaultBg: "#1cb691",
                              defaultHoverColor: "#fff",
                              defaultHoverBorderColor: "#1cb691cc",
                              defaultHoverBg: "#1cb691cc",
                              defaultActiveColor: "#fff",
                              defaultActiveBorderColor: "#1cb691",
                              defaultActiveBg: "#1cb691",
                            },
                          },
                        }}
                      >
                        <Button
                          className={style.button}
                          onClick={onShare}
                          disabled={checkList.length < 1}
                        >
                          <div className={style.button_content}>
                            <div
                              className={
                                checkList.length < 1
                                  ? style.check_cnt
                                  : `${style.check_cnt} ${style.active}`
                              }
                            >
                              {checkList.length}
                            </div>
                            <p>{t("HOTDESKING.BUTTON.SEND")}</p>
                            <SendIcon />
                          </div>
                        </Button>
                      </ConfigProvider>
                    </section>
                  )}
                </>
              )}
            </section>
          </section>
        </section>
      </section>
    </Modal>
  );
}
function BookEndpointModal({
  open,
  date,
  time,
  resource,
  onClose,
  onRefresh,
  onError,
}) {
  const expandContent = {
    participant: {
      title: "참석자 추가",
      content: <></>,
    },
    endpoint: {
      title: "영상회의 설정",
      content: <></>,
    },
  };
  const endpointOptions = {
    use: "Y",
    not_use: "N",
  };
  // const [loading, setLoading] = useState(false);
  const [isExpand, setIsExpand] = useState(false);
  const [expandInfo, setExpandInfo] = useState({
    title: "",
    content: <></>,
  });
  const [info, setInfo] = useState({
    title: "",
    content: "",
    participant: [
      { name: "참석자1" },
      { name: "참석자1" },
      { name: "참석자1" },
      { name: "참석자1" },
      { name: "참석자1" },
      { name: "참석자1" },
    ],
    use_endpoint: "N",
  });

  const closeModal = () => {
    onClose();
    const timeout = setTimeout(() => {
      // setLoading(false);
      setIsExpand(false);
      setExpandInfo({
        type: "",
        title: "",
        content: <></>,
      });
    }, 500);
    return () => clearTimeout(timeout);
  };
  // const onSuccess = () => {
  //   onRefresh();
  //   closeModal();
  // };

  const onBook = () => {};

  const formatTime = (time) => {
    return dayjs(new Date(date + " " + time)).format("HH:mm");
  };

  const onExpand = (info) => {
    setIsExpand(true);
    setExpandInfo(info);
  };

  // const onContract
  // 여기까지 작업 중

  // const onChangeType = (e) => {
  //   const value = e.target.value;

  //   if (value === "Y") {
  //     onExpand(expandContent.endpoint);
  //   } else {
  //   }
  //   setInfo({ ...info, use_endpoint: value });
  // };

  return (
    <Modal
      className={style.modal}
      open={open}
      closable={false}
      mask={false}
      footer={<></>}
      centered
    >
      <ConfigProvider
        theme={{
          components: {
            Tag: {
              defaultBg: "#fff",
              defaultColor: "#1cb691",
            },
            Radio: {
              buttonBg: "#fff !important",
              buttonColor: "#1cb691",
              buttonSolidCheckedBg: "#1cb691 !important",
              buttonSolidCheckedColor: "#fff !important",
            },
          },
        }}
      >
        <section className={`${style.modal_content} ${style.endpoint}`}>
          <section className={style.content_header}>
            <p className={style.header_title}>회의실 예약</p>
            <CloseOutlined className={style.header_icon} onClick={closeModal} />
          </section>

          <section
            className={
              isExpand
                ? `${style.content_section} ${style.expand}`
                : style.content_section
            }
          >
            <section className={style.info_section}>
              <section className={style.input_section}>
                <article className={style.input_item}>
                  <p className={style.input_title}>예약 일시</p>
                  <div className={`${style.input_grid} ${style.half}`}>
                    <Input
                      className={style.input_content}
                      value={date}
                      allowClear={false}
                      readOnly
                    />
                    <Input
                      className={style.input_content}
                      value={
                        formatTime(time.start) + " - " + formatTime(time.end)
                      }
                      allowClear={false}
                      readOnly
                    />
                  </div>
                </article>

                <article className={style.input_item}>
                  <p className={style.input_title}>회의 명</p>
                  <Input
                    className={style.input_content}
                    value={info.title}
                    onChange={(e) =>
                      setInfo({ ...info, title: e.target.value })
                    }
                    allowClear={false}
                  />
                </article>

                <article className={style.input_item}>
                  <p className={style.input_title}>참석자</p>
                  <div className={`${style.input_grid} ${style.button}`}>
                    <div className={`${style.input_content} ${style.line}`}>
                      <section className={style.tags_section}>
                        {info.participant.map((item, idx) => (
                          <Tag key={idx} className={style.tags_content}>
                            {item.name}
                          </Tag>
                        ))}
                      </section>
                    </div>

                    <Button
                      className={style.input_content}
                      icon={<PlusOutlined />}
                      onClick={() => onExpand(expandContent.participant)}
                    />
                  </div>
                </article>

                <article className={style.input_item}>
                  <p className={style.input_title}>메모</p>
                  <Input.TextArea
                    className={style.input_content}
                    value={info.content}
                    onChange={(e) =>
                      setInfo({ ...info, content: e.target.value })
                    }
                    row={2}
                    maxLength={100}
                    allowClear={false}
                  />
                </article>

                <article className={style.input_item}>
                  <p className={style.input_title}>영상회의</p>
                  <Radio.Group
                    className={`${style.input_content} ${style.type}`}
                    optionType="button"
                    buttonStyle="solid"
                    value={info.use_endpoint}
                    onChange={(e) => {
                      setInfo({ ...info, use_endpoint: e.target.value });
                    }}
                  >
                    <Radio value={endpointOptions.use}>
                      <p>사용</p>
                    </Radio>
                    <Radio value={endpointOptions.not_use}>
                      <p>미사용</p>
                    </Radio>
                  </Radio.Group>
                </article>
              </section>

              <section
                className={style.button_section}
                onClick={() => onBook()}
              >
                <div className={style.button_label}>
                  <div className={style.icon}>
                    <UnorderedListOutlined />
                  </div>
                  <p>예약</p>
                </div>
                <RightOutlined className={style.icon} />
              </section>
            </section>

            <section className={style.list_section}>
              <section className={style.list_header}>
                <p>{expandInfo.title}</p>
              </section>

              <section className={style.list_content}>
                <section className={style.list_content_section}>
                  {expandInfo.content}
                </section>
              </section>
            </section>
          </section>
        </section>
      </ConfigProvider>
    </Modal>
  );
}
function SeatGuide() {
  const { t } = useTranslation();
  const type = [
    {
      value: "IN_USE",
      label: t("HOTDESKING.SEAT_GUIDE.IN_USE"),
      color: "#fea85e",
      blur: "#fea85ecc",
    },
    {
      value: "NOT_USE",
      label: t("HOTDESKING.SEAT_GUIDE.NOT_USE"),
      color: "#5ee2c3",
      blur: "#5ee2c3cc",
    },
    {
      value: "AVAILABLE",
      label: t("HOTDESKING.SEAT_GUIDE.RESERVED"),
      color: "#f16569",
      blur: "#f16569cc",
    },
  ];

  return (
    <section className={style.seat_section}>
      {type.map((item, idx) => (
        <div key={idx} className={style.seat_item}>
          <span
            className={style.seat_color}
            style={{
              backgroundColor: item.color,
              outline: `3px solid ${item.blur}`,
            }}
          />
          <p className={style.seat_label}>{item.label}</p>
        </div>
      ))}
    </section>
  );
}
